import { ChevronLeft, ChevronRight } from '@/components/icons'
import { Button } from '@/components/ui/button'

interface WeekNavigationProps {
  className?: string
  currentWeekStart: Date
  onWeekChange: (date: Date) => void
}

export function WeekNavigation({ className = '', currentWeekStart, onWeekChange }: WeekNavigationProps) {


  // Format date to "DD-MMM" format
  const formatWeekStart = (date: Date): string => {
    const day = date.getDate().toString().padStart(2, '0')
    const month = date.toLocaleDateString('en-US', { month: 'short' })
    return `${day}-${month}`
  }

  // Navigate to previous week
  const goToPreviousWeek = () => {
    const newDate = new Date(currentWeekStart)
    newDate.setDate(newDate.getDate() - 7)
    onWeekChange(newDate)
  }

  // Navigate to next week
  const goToNextWeek = () => {
    const newDate = new Date(currentWeekStart)
    newDate.setDate(newDate.getDate() + 7)
    onWeekChange(newDate)
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Previous week button */}
      <Button
        variant="default"
        size="icon"
        onClick={goToPreviousWeek}
        className="h-8 w-8 p-0 rounded-full bg-primary text-primary-foreground hover:bg-primary/90"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>

      {/* Week display */}
      <div className="text-center px-2">
        <div className="text-xs text-muted-foreground italic">Week starting</div>
        <div className="text-sm font-semibold text-foreground">
          {formatWeekStart(currentWeekStart)}
        </div>
      </div>

      {/* Next week button */}
      <Button
        variant="default"
        size="icon"
        onClick={goToNextWeek}
        className="h-8 w-8 p-0 rounded-full bg-primary text-primary-foreground hover:bg-primary/90"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
